import styled from "styled-components";
import { Flex } from "rebass/styled-components";

import { CONTENT_MAX_WIDTH } from "../styledComponents";

// Mirrors Homepage/index.tsx's HomepageContainer + CappedContent (not
// exported from there, and importing them directly would create a cycle
// since that file imports ActivityFeedHome). HomepageWrapper is a row-flex
// container (display:flex, no flex-direction override) — without this
// column wrapper, ClipOfTheDay and CappedContent end up as side-by-side flex
// items instead of stacked, which also breaks ClipOfTheDay's negative-margin
// background bleed (it bleeds against HomepageWrapper's padding and needs a
// full-width column ancestor to do that correctly).
export const HomepageContainer = styled(Flex)`
  flex-direction: column;
  gap: 32px;
  padding-bottom: 80px;
  width: 100%;
`;

export const CappedContent = styled(Flex)`
  align-self: center;
  flex-direction: column;
  gap: 32px;
  margin: 0 auto;
  max-width: ${CONTENT_MAX_WIDTH};
  width: 100%;
`;

export const FeedColumns = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 32px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const FeedMain = styled.div`
  flex: 1;
  min-width: 0;
`;

export const FeedAside = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 16px;
  width: 340px;

  @media (max-width: 900px) {
    width: 100%;
  }
`;
